import { render } from "./PermissionEmployee.vue?vue&type=template&id=8b3e2d24&scoped=true"
import script from "./PermissionEmployee.vue?vue&type=script&lang=js"
export * from "./PermissionEmployee.vue?vue&type=script&lang=js"

import "./PermissionEmployee.vue?vue&type=style&index=0&id=8b3e2d24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3e2d24"]])

export default __exports__